const thaibaht = require('thai-baht-text');

Vue.filter('numeral', (value, precision = 2) => {
  return numeral(value).format(`#,0.[00]`);
});

Vue.filter('percent', (value) => {
  return numeral(value).format('0.00');
});

Vue.filter('moment', (value) => {
  return moment(value).format('D MMM YY H:mm:ss');
});

Vue.filter('date', (value) => {
  let date = moment(value);

  if (!date.isValid())
    return '';

  return date.format('D MMMM ') + (date.year() + 543);
});

Vue.filter('time', (value) => {
  return moment(value).format('H:mm:ss');
});

Vue.filter('thaibaht', (value) => {
  return thaibaht(value);
});